import { LoginCallback, useOktaAuth } from "@okta/okta-react";
import React, { useEffect } from "react";

const OktaError = ({ error }) => {
  if (error.name && error.message) {
    return (
      <p>
        {error.name}: {error.message}
      </p>
    );
  }
  return <p>Error: {error.toString()}</p>;
};

const OktaLoginCallback = ({ errorComponent, loadingElement = null, onAuthResume, authStore }) => {
  const { authState } = useOktaAuth();

  useEffect(() => {
    if (authState?.isAuthenticated) {
      authStore.setOktaSession();
      authStore.getUserInfo();
    }
  }, [authState?.isAuthenticated, authStore]);

  return (
    <LoginCallback
      errorComponent={errorComponent || OktaError}
      loadingElement={loadingElement}
      onAuthResume={onAuthResume}
    />
  );
};

export default OktaLoginCallback;
